<span>
    <ng-container *ngIf="isParamValue; else noParamValue">
        <span
            (click)="$event.stopPropagation(); copyValue(value)"
            [pTooltip]="'copy'|translate"
            tooltipPosition="top"
            tooltipStyleClass="{{isCopyActive ? 'tooltip-pinned' : ''}}"
            style="cursor: pointer;"
        >
            {{value}}
        </span>
    </ng-container>
    <ng-template #noParamValue>
        {{(value || 0) | number:'1.0-0'}} {{unit}}
    </ng-template>
</span>
